import { useParams, useSearchParams } from 'react-router-dom';
import { useDocumentTitle } from '../hooks/useDocumentTitle'
import axios from 'axios';
import { API_BASE_URL } from '../utils/config';
import { useEffect, useState } from 'react';
import Loading from '../components/Loading/Loading';
import "../styles/main.css";
import Header from '../components/Header/Header';
import style from './Order.module.css';
import { calculateDiscountPercentage, formatDateRange, formatDatetimeAutocancel, formatMoney, formatPhoneNumber, getGuestsWord, getHoursFromTS, isWeekend, processSmeta } from '../utils/utils';
import Buttons from '../components/Buttons/Buttons';
import { useSnackbarAlert } from '../providers/SnackbarProvider';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function Order() {
    const snackbar = useSnackbarAlert();
    const { link } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const [loading, setLoading] = useState(false);
    const [order, setOrder] = useState(null);
    const [headerData, setHeaderData] = useState(null);

    const [smetaHallPriceFull, setSmetaHallPriceFull] = useState(null);
    const [smetaHallPrice, setSmetaHallPrice] = useState(null);
    const [smetaHallSale, setSmetaHallSale] = useState(0);

    const [smetaEtc, setSmetaEtc] = useState(null);
    const [smetaEtcPrice, setSmetaEtcPrice] = useState(null);
    const [smetaEtcPriceFull, setSmetaEtcPriceFull] = useState(null);

    const [paymentsAll, setPaymentsAll] = useState(null);
    const [summa, setSumma] = useState(null);
    const [summaFull, setSummaFull] = useState(null);
    const [summaRemain, setSummaRemain] = useState(null);

    const [predoplata, setPredoplata] = useState(0);

    const [predoplataLoading, setPredoplataLoading] = useState(false);
    const [oplataLoading, setOplataLoading] = useState(false);

    const paymentsTypes = {
        1: 'Наличные',
        2: 'Терминал',
        3: 'Перевод',
        4: 'Сертификат',
        5: 'Онлайн'
    }

    useDocumentTitle(order?.status === "success" ? `Kinoroom - Бронь №${order?.order.ID}` : "Kinoroom - Бронь");

    useEffect(() => {
        getOrder();

        async function getOrder() {
            setLoading(true);

            if (searchParams.get('type') === "success")
                await new Promise(res => setTimeout(res, 2000));

            try {
                const res = await axios.post(`${API_BASE_URL}/api/index.php`, {
                    type: 'openOrder',
                    id: null,
                    link: link
                }, {
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    withCredentials: true
                });
                
                // console.log(res.data);
                if (res.data.error) {
                    setOrder({"order": {"Type": 0}})
                    setHeaderData(
                        {
                            title: "Бронь не найдена",
                            text: "",
                            step: 8,
                            status: 0
                        }
                    )
                    return;
                }

                setOrder(res?.data);
                setHeaderData(
                    {
                        title: "Бронь №"+res?.data.order.ID,
                        text: res?.data.order.Type === 0 ? "Бронирование отменено" : "",
                        step: 7,
                        status: res?.data.order.Type
                    }
                )

                if (res?.data.order.Type === 1) {
                    setPredoplata(1000);
                    if (isWeekend(res.data.order.Start * 1000)) setPredoplata(1500);
                    if (res.data.order.End - res.data.order.Start > 14400) setPredoplata(2000);
                    res.data.smets.forEach(smeta => {
                        if (smeta.Name.indexOf("Пакет \"") >= 0) setPredoplata(2000);
                    });
                }
            } catch (err) {
                // console.log(err);
                snackbar.error("Ошибка загрузки бронирования. Перезагрузите страницу или попробуйте позже.");
            } finally {
                setLoading(false);

                if (searchParams.get('type') === "success") {
                    snackbar.success("Платеж успешно добавлен.");
                    setSearchParams('');
                } else if (searchParams.get('type') === "fail") {
                    snackbar.error("Ошибка платежа.");
                    setSearchParams('');
                }
            }
        }
    }, []);

    useEffect(() => {
        if (order?.status !== "success") return;

        let hallFull = 0;
        let hall = 0;
        let sale = 0;

        let smetaEtc = [];
        let smetaEtcPrice = 0;
        let smetaEtcPriceFull = 0;

        let paymentsAll = null;

        order.smets.forEach(smeta => {
            let process = processSmeta(smeta);
            if (smeta.Type === 0) {
                hallFull += process.fullPrice;
                hall += process.discountedPrice;
                sale = smeta.Sale;
            } else {
                smetaEtc.push(process);
                smetaEtcPriceFull += process.fullPrice;
                smetaEtcPrice += process.discountedPrice;
            }
        });

        order.payments.forEach(payment => {
            paymentsAll += payment.Summa;
        });
        
        setSmetaHallPriceFull(hallFull);
        setSmetaHallPrice(hall);
        setSmetaHallSale(calculateDiscountPercentage(hallFull, hall, { decimals: 1 }));

        setSmetaEtc(smetaEtc);
        setSmetaEtcPriceFull(smetaEtcPriceFull);
        setSmetaEtcPrice(smetaEtcPrice);

        setPaymentsAll(paymentsAll);
        setSumma(hall + smetaEtcPrice);
        setSummaFull(hallFull + smetaEtcPriceFull);
        setSummaRemain((hall + smetaEtcPrice) - paymentsAll);
    }, [order]);

    async function createPay(sum,category) {
        if (category === 1) setPredoplataLoading(true);
        if (category === 2) setOplataLoading(true);

        try {
            const res = await axios.post(`${API_BASE_URL}/api/index.php`, {
                type: 'createPay',
                id: order?.order.ID,
                sum: sum,
                category: category,
                link: link
            }, {
                headers: {
                'Content-Type': 'application/json'
                },
                withCredentials: true
            });
            
            // console.log(res?.data);
            window.location.href = res?.data.paymentURL;
            // window.location.replace(res?.data.paymentURL);
            // navigate(res.data.paymentURL);
        } catch (err) {
            // console.log(err.response.data);
            snackbar.error("Ошибка создания платежа.");
        } finally {
            setPredoplataLoading(false);
            setOplataLoading(false);
        }
    }

    return (
        <>
            {loading ? <Loading /> 
            : order ? (
                <div className="background">
                    <Header headerData={headerData || {}} />
                    {order?.status === "success" && (
                        <>
                            <div className={style.info_container}>
                            <div className={style.info_block}>
                                <div className={style.title}>{formatDateRange(new Date(order.order.Start * 1000), (order.order.End - order.order.Start) / 60)}</div>
                                <div className={style.text}><a href={order.order.Link} target="_blank">г.Москва, {order.order.AddressFull}</a></div>
                                <div className={style.text}>Зал №{order.order.Hall}, {getGuestsWord(order.order.CountPeople)}</div>
                            </div>
                            <div className={style.info_block}>
                                <div className={style.text}>{order.client.Name}, {formatPhoneNumber(order.client.Phone)}</div>
                                {order.client.Email && <div className={style.text}>{order.client.Email}</div>}
                            </div>
                        </div>
                        {order?.order?.Autocancel !== 0 && (
                            <div className={style.text_autocancel}>{formatDatetimeAutocancel(order.order.Autocancel)}</div>
                        )}
                        <div className={style.main_container}>
                            {smetaHallPrice !== 0 && (
                                <div className={style.main_block}>
                                    <div className={style.main_title}>Стоимость зала</div>
                                    <div className={style.main_subtitle}>Сумма — {formatMoney(smetaHallPrice)} ₽</div>
                                    <div className={style.main_elements_container}>
                                        <div className={style.main_element_block}>
                                            <div className={style.main_element_name}>Аренда ({getHoursFromTS(order.order.Start, order.order.End)})</div>
                                            <div className={style.main_element_price}>{formatMoney(smetaHallPriceFull)} ₽</div>
                                        </div>
                                        {smetaHallSale !== '0' && smetaHallSale !== '0%' && smetaHallSale !== 0 && (
                                            <div className={style.main_element_block}>
                                                <div className={style.main_element_name}>Персональная скидка</div>
                                                <div className={style.main_element_price}>{smetaHallSale}%</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {smetaEtc?.length !== 0 && (
                                <>
                                    {smetaHallPrice !== 0 && <div className={style.main_separator}></div>}
                                    <div className={style.main_block}>
                                        <div className={style.main_title}>Дополнительно</div>
                                        <div className={style.main_subtitle}>Сумма — {formatMoney(smetaEtcPrice)} ₽</div>
                                        <div className={style.main_elements_container}>
                                            {smetaEtc?.map((smeta) => (
                                                <div key={`smeta_block_${smeta.ID}`} className={style.main_element_block}>
                                                    <div className={style.main_element_name}>{smeta.Name} {smeta.Count > 1 && `(x${smeta.Count})`}
                                                        {smeta.IsAdmin === 1 && <div className={style.main_element_subname}>Добавлено менеджером</div>}
                                                        {smeta.saleDisplay !== "—" && <div className={style.main_element_subname}>Скидка — {smeta.saleDisplay}</div>}
                                                    </div>
                                                    <div className={style.main_element_price}>{formatMoney(smeta.discountedPrice)} ₽
                                                        {smeta.fullPrice !== smeta.discountedPrice && (
                                                            <div className={style.main_element_subprice}>{formatMoney(smeta.fullPrice)} ₽</div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className={style.main_separator}></div>
                            <div className={style.summa}>Сумма:
                                <span>{formatMoney(summa)} ₽</span>
                                {summa !== summaFull && <span>{formatMoney(summaFull)} ₽</span>}
                            </div>
                        </div>
                        {order?.payments?.length !== 0 && (
                            <div className={style.main_container}>
                                <div className={style.main_block}>
                                    <div className={style.main_title}>Платежи</div>
                                    <div className={style.main_subtitle}>Всего оплачено — {formatMoney(paymentsAll)} ₽</div>
                                    <div className={style.main_elements_container}>
                                        {order.payments.map((payment) => (
                                            <div key={`payment-${payment.ID}`} className={style.main_element_block}>
                                                <div className={style.main_element_name}>
                                                    {payment.Category === 3 ? "Возврат" : paymentsTypes[payment.Type]}
                                                    <div className={style.main_element_subname}>{payment.Timestamp}</div>
                                                    {payment.IsAdmin === 1 && <div className={style.main_element_subname}>Добавлено менеджером</div>}
                                                </div>
                                                <div className={style.main_element_price}>{formatMoney(payment.Summa)} ₽</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className={style.main_separator}></div>
                                {summaRemain > 0 ? (
                                    <div className={style.summa}>Остаток: <span>{formatMoney(summaRemain)} ₽</span></div>
                                ) : (
                                    <div className={style.summa}>Оплачено полностью</div>
                                )}
                            </div>
                        )}
                        <div className={style.accordion_block}>
                            <Accordion slotProps={{ heading: { component: 'h4' } }}>
                                <AccordionSummary
                                    expandIcon={<KeyboardArrowDownIcon />}
                                >
                                    <div className={style.accordion_title}>Правила бронирования</div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className={style.accordion_text}>
                                        <p>- Перенос или возврат предоплаты возможен при отмене не позднее чем за 6 часов до начала.</p>
                                        <p>- При более поздней отмене сумма не возвращается и не переносится.</p>
                                        <p>- Если до начала бронирования остаётся менее 6 часов, в случае отмены предоплата не возвращается.</p>
                                        <p>- Корректировка времени брони невозможна, если до неё осталось менее 1.5 часа.</p>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                        {(order.order.Predoplata > 0 && order.order.Type !== 0) && 
                            <Buttons button1={{
                                text: `Внести предоплату (${formatMoney(order.order.Predoplata)} ₽)`,
                                onClick: () => createPay(order.order.Predoplata, 1),
                                loading: predoplataLoading
                            }}/>
                        }
                        {(summaRemain > 0 && order.order.Type !== 0) &&
                            <Buttons button1={{
                                text: `Оплатить полностью (${formatMoney(summaRemain)} ₽)`,
                                onClick: () => createPay(summaRemain, 2),
                                loading: oplataLoading
                            }}/>
                        }
                        </>
                    )}
                </div>
            ) : null}
        </>
    )
}
